import axios from 'axios';
import { ElMessage } from 'element-plus';
import { Common } from '@/common';
const userInfo = JSON.parse(decodeURIComponent(Common.getCookie("QDS_LOGIN_INFO_OFFICE") ? Common.getCookie("QDS_LOGIN_INFO_OFFICE") : "{}"));
let requestParams = {
	identityIde: userInfo.userId,
	userIde: userInfo.userId,
	h5Query: 0,
	appKey: "quandashi6495266219",
	timestamp: new Date().getTime(),
	format: "json",
	signMethod: "md5",
	executor: userInfo.userId,
	v: "1.0",
	sign: new Date().getTime() + '' + Math.floor((Math.random() * 10000) + 1)
}
axios.defaults.baseURL = process.env.VUE_APP_API_URL
axios.defaults.timeout = 30000;

axios.interceptors.request.use((config) => {
	requestParams.timestamp = new Date().getTime(),
	requestParams.sign = new Date().getTime() + '' + Math.floor((Math.random() * 10000) + 1)
	config.data = { ...requestParams, ...config.data }
	return config;
}, (error) => {
	return Promise.reject(error);
});

axios.interceptors.response.use((res) => {
	if (res.data.subCode == 10004) {
		sessionStorage.clear();
		ElMessage.error("登录信息有误，请重新登录！");
		window.location.href = process.env.VUE_APP_LOGIN_URL + window.location.href
	}
	return res;
}, (error) => {
	if (error.message.includes('timeout')) {
		ElMessage.error("网络超时,请稍后重试");
	}
	return Promise.reject(error);
});

export default axios;
